import { render, staticRenderFns } from "./LuckAwardPopup.vue?vue&type=template&id=5d0dce23&scoped=true"
import script from "./LuckAwardPopup.vue?vue&type=script&lang=js"
export * from "./LuckAwardPopup.vue?vue&type=script&lang=js"
import style0 from "./LuckAwardPopup.vue?vue&type=style&index=0&id=5d0dce23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0dce23",
  null
  
)

export default component.exports